<div class="section-card">
  <div
    class="section-header mb-3 d-flex align-items-center justify-content-between"
  >
    <h4 class="section-title">Fare Details</h4>
    <a
      href="javascript:void(0)"
      *ngIf="!showEdit.includes(orderDetails?.state?.code)"
      class="btn-link btn-link-primary"
      (click)="openAddEstimateModal()"
      >Edit</a
    >
  </div>
  <div class="order-type-card">
    <div class="order-type-content d-flex align-items-center">
      <div>
        <h3 class="font-extrabold text-primary-light-950">
          ₹{{ this.orderDetails?.totals?.amount }}
        </h3>
        <!-- <p class="update-time">
          Last update
          {{
            this._commonService.getStatusDate(
              this.orderDetails?.historyCompact,
              'Estimation'
            ) | date : 'HH:mm ddMMM yyyy'
          }}
        </p> -->
      </div>
    </div>
  </div>
  <button class="btn-link btn-link-primary" (click)="openViewEstimateModal()">
    VIEW FARE DETAILS
  </button>
</div>
